var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "contentView" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "mb-0" }, [
            _vm._v(" " + _vm._s(_vm.$t("content.content-library")) + " ")
          ]),
          _vm.loading
            ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
            : _vm._e(),
          _c(
            "v-card-text",
            { staticClass: "mt-5" },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.sortOptions.map(function(x) {
                    return Object.assign({}, x, { text: _vm.$t(x.text) })
                  }),
                  "item-text": "text",
                  "item-value": "value",
                  label: "Sort by",
                  dense: ""
                },
                model: {
                  value: _vm.selectedSort,
                  callback: function($$v) {
                    _vm.selectedSort = $$v
                  },
                  expression: "selectedSort"
                }
              }),
              !_vm.loading
                ? _c(
                    "v-container",
                    [
                      _vm.sortedItems.length > 0
                        ? _c(
                            "v-row",
                            _vm._l(_vm.sortedItems, function(item) {
                              return _c(
                                "v-col",
                                {
                                  key: item.id,
                                  staticClass: "d-flex flex-column",
                                  attrs: { cols: "12", sm: "6", md: "4" }
                                },
                                [
                                  _c("module-card", {
                                    staticClass: "mb-1 flex-grow-1",
                                    attrs: { model: item, available: "" },
                                    on: {
                                      edit: function($event) {
                                        return _vm.editItem(item)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _c(
                            "v-row",
                            [
                              _c("v-col", [
                                _vm._v(
                                  _vm._s(_vm.$t("content.no-available-modules"))
                                )
                              ])
                            ],
                            1
                          )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.loading
                ? _c("v-container", [
                    _vm._v(" " + _vm._s(_vm.$t("global.loading")) + " ")
                  ])
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }